<template>
  <div class="wrapper">
    <div class="logo">
      <img src="@/assets/brief/logo.png">
    </div>
    <ul class="content">
      <li class="doctor_name">
        <img :src="drdetails.img">
        <span>
          <p>{{drdetails.drname}}</p>
          <p>{{drdetails.professional}}</p>
        </span>
      </li>
      <li class="docbrief">{{drdetails.introduce}}</li>
    </ul>
  </div>
</template>

<script>
import { GetRequest } from "@/tool/parameter.js"
export default {
  data() {
    return {
      drdetails: {}
    }
  },
  created() {
    this.drdetails = JSON.parse(sessionStorage.getItem("doctorDetails"))
  },
  methods: {
    
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  position: relative;
  .logo{
    widows: 375px;
    height: 183px;
    >img{
      widows: 100%;
      height: 100%;
    }
  }
  .content{
    position: absolute;
    top: 134px;
    left: 0px;
    width: 355px;
    margin: 0px 10px;
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    padding: 10px;
    .doctor_name{
      display: flex;
      flex-flow: row nowrap;
      margin-bottom: 20px;
      >img{
        width: 54px;
        height: 66px;
      }
      >span{
        margin-left: 15px;
        >p:nth-child(1){
          font-size: 18px;
          font-weight: bold;
          margin: 10px 0px;
        }
        >P:nth-child(2){
          font-size: 14px;
          color: #AEAEAE;
        }
      }
    }
    .docbrief{
      margin: 0px 25px;
      padding: 30px 8px 10px;
      border-top: 1px solid #C2C2C2;
      color: #707070;
      letter-spacing: 1px;
      line-height: 22px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/experts/doctorDetails.vue